import { DayRange } from '../models/models';
import { CustomRangeSelectionStrategy } from '../strategies/custom-range-selection.strategy';


export const defaultDayRange: DayRange = {
  daysInPast: 5,
  daysInFuture: 5,
};

export const formatDate = (date: Date) =>
  `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;

export const buildRequestedDates = (dayRange: DayRange, startDate: Date = new Date()) => {
  const pastDate = new Date(startDate);
  pastDate.setDate(pastDate.getDate() - dayRange.daysInPast);
  const futureDate = new Date(startDate);
  futureDate.setDate(futureDate.getDate() + dayRange.daysInFuture);

  return [formatDate(pastDate), formatDate(futureDate)];
};

export const dateTimeToStringLocale = (date: Date) => date.toLocaleString('nl-NL', {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
})
  .replace(/-/g, '/');

export const customRangeSelectionStrategyFactory = () =>
  new CustomRangeSelectionStrategy<Date>(11);
